<template>
  <div>
    <div style="text-align: right;padding-bottom: 9px;" id="rccx">
      <b>权限属性：</b>
      <el-input style="width: 120px;"
                v-model="queryParams.role"
                placeholder="请输入权限"/>
      <b>权限名称：</b>
      <el-input style="width: 120px;"
                v-model="queryParams.rolename"
                placeholder="权限名称"/>
      <el-button type="primary"  @click="getList"  size="medium" round><i class="el-icon-search"></i>查询</el-button>
      <el-button type="primary"  @click="createdata"  size="medium" round><i class="el-icon-circle-plus"></i>新建权限</el-button>
      <el-button type="warning"  @click="cleardata"  size="medium" round><i class="el-icon-refresh"></i>重置</el-button>

    </div>

    <el-table v-loading="loading"
              :data="tableData"
              style="width: 100%">
      <el-table-column
          type="index"
          align="center"
          width="70" label="序号">
        <template slot-scope="scope">
          <div v-text="(queryParams.pageNum-1)*queryParams.pageSize+1+scope.$index"></div>
        </template>
      </el-table-column>
      <el-table-column

          label="权限"
          prop="role" align="center">
      </el-table-column>
      <el-table-column
          label="权限名称"
          prop="rolename" align="center">
      </el-table-column>
      <el-table-column
          align="center" label="操作" width="200">

        <template slot-scope="scope">
          <el-button
              size="mini"
              @click="handleEdit( scope.row)">
            <i class="el-icon-setting"></i>
            修改权限
          </el-button>
          <el-button
              size="mini"
              type="danger"
              @click="deleterole(scope.$index, scope.row)">  <i class="el-icon-delete"></i>删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <template>
      <div>

        <pagination
            id="roleListpage"
            v-if="total > 0"
            :total="total"
            :center="true"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getList"
        />
      </div>
    </template>



    <el-dialog :title="selectTable.title" :visible.sync="dialogFormVisible">
      <el-form :model="selectTable" :rules="formRules" ref="form">
        <el-form-item label="权限:" label-width="100px" prop="role">
          <p v-if="selectTable.id != 0" style="margin: 0px">{{ selectTable.role }}</p>
          <el-input
              v-if="selectTable.id == 0"
              v-model="selectTable.role"
              auto-complete="off"
              placeholder="请输入权限标识"
          ></el-input>
        </el-form-item>

        <el-form-item label="权限名称:" label-width="100px" prop="rolename">
          <p v-if="selectTable.id != 0" style="margin: 0px">{{ selectTable.rolename }}</p>
          <el-input
              v-if="selectTable.id == 0"
              v-model="selectTable.rolename"
              auto-complete="off"
              placeholder="请输入权限名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-tree
          class="tree-border"
          :data="selectTable.menuOptions"
          show-checkbox
          :default-checked-keys="selectTable.defalutCheckArr"
          ref="menu"
          node-key="pid"
          :check-strictly=false
          empty-text="加载中，请稍候"
          :props="defaultProps"
      ></el-tree>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="createtree">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from "../../component/Pagination/index.vue";

export default {
  components: {Pagination},
  data() {
    // 自定义权限标识校验
    const validateRole = (rule, value, callback) => {
      // 只校验格式，空值由 required 处理
      if (value && !/^[a-zA-Z][a-zA-Z0-9_:]*$/.test(value)) {
        callback(new Error('权限标识格式不正确（字母开头，可包含字母、数字、冒号、下划线）'));
      } else {
        callback();
      }
    };

// 自定义权限名称校验
    const validateRolename = (rule, value, callback) => {
      // 只校验长度，空值由 required 处理
      if (value && (value.length < 2 || value.length > 20)) {
        callback(new Error('权限名称长度在 2 到 20 个字符之间'));
      } else {
        callback();
      }
    };

    return {
      formRules: {
        role: [
          { required: true, message: '权限标识不能为空', trigger: 'blur' },
          { validator: validateRole, trigger: 'blur' }
        ],
        rolename: [
          { required: true, message: '权限名称不能为空', trigger: 'blur' },
          { validator: validateRolename, trigger: 'blur' }
        ]
      },
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        role: undefined,
        rolename: undefined,
        status: undefined
      },
      selectTable:{
        title:'新增权限',
        id:0,
        role:'',
        rolename:'',
        menuOptions:[],
        defalutCheckArr:[],
        rptid:0
      },
      defaultProps: {
        children: "children",
        label: "pname"
      },
      // 菜单列表
      menuOptions: [],
      dialogFormVisible: false,
      dialogFormData: [],
      tableData: [],
      tablelistData: [],
      search: '',
      loading: false
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    cleardata(){
      this.queryParams= this.$options.data().queryParams
      this.getList()
    },
    getList() {
      this.loading = true;
      this.$request.postHttp({
        url: "/system/rolelist",
        data: JSON.stringify(this.queryParams),
        success: (data) => {
          this.tableData = data.data.records
          this.total = data.data.total
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
      this.loading = false;
    },
    deleterole(index, row){
      this.$confirm('确认删除吗?', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        this.$request.postHttp({
          url: "/system/deleterole",
          params:{rid:row.id},
          success: (data) => {
            this.$message.success('删除成功！')

            this.getList();
          },
          error: (error) => {
            this.$message.error('删除失败！')

            console.error("Error:", error);
            // 执行失败时的操作
          },
        })

      }).catch(() => {
        this.$message.info('操作已取消')
      });
    },
    createdata(){
      this.handleEdit({id:0,title:'新增权限'})
    },
    handleEdit(row) {
      this.selectTable.id=row.id
      this.selectTable.role=row.role
      this.selectTable.rolename=row.rolename
      this.$request.getHttp({
        url: "/system/getroletree",
        params:{rid:this.selectTable.id},
        success: (data) => {
          this.selectTable.defalutCheckArr=data.data.checkData
          this.selectTable.rptid=data.data.pid
          this.selectTable.menuOptions=this.listToTree(data.data.treeData[0])
          this.dialogFormVisible = true;
          if( this.$refs.form){
            this.$refs.form.clearValidate();  // 清空所有验证提示
          }

        },
        error: (error) => {
          this.$message.error('打开失败！')

          // 执行失败时的操作
        },
      })
    },
    handleDelete(index, row) {
      this.tableData.splice(index, 1);
    },
    listToTree(list) {
      let map = {}, node, tree = [], i;
      for (i = 0; i < list.length; i++) {
        map[list[i].pid] = i; // 初始化映射
        list[i].children = []; // 初始化children
      }
      for (i = 0; i < list.length; i++) {
        node = list[i];
        if (node.parentid != '0') {
          // 找到当前项的父项的索引
          let parent = list[map[node.parentid]];
          // 将当前项添加到父项的children数组中
          parent.children.push(node);
        } else {
          tree.push(node); // 添加到树结构中
        }
      }
      return tree;
    },
    // 树权限（展开/折叠）
    handleCheckedTreeExpand(value, type) {
      let treeList = this.menuOptions;
      for (let i = 0; i < treeList.length; i++) {
        this.$refs.menu.store.nodesMap[treeList[i].id].expanded = value;
      }
    },
    // 树权限（全选/全不选）
    handleCheckedTreeNodeAll(value) {
      console.log(value)
      console.log( this.getSimpleCheckedNodes( this.$refs.menu))
        this.$refs.menu.setCheckedNodes(value ? this.selectTable.menuOptions: []);
    },
    getSimpleCheckedNodes(store){
      const checkedNodes=[]
      const traverse=(node)=>{
        const childNodes=node.root ? node.root.childNodes : node.childNodes  //这些都是实例上的东西,不用管,拿着用就行
        childNodes.forEach(child=>{
          if(child.checked){
            checkedNodes.push(child.data)
          }
          if(child.indeterminate){
            traverse(child)
          }
        })
      }

      traverse(store)
      return checkedNodes
    },
    createtree(){
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.selectTable.defalutCheckArr=this.$refs.menu.getCheckedKeys()
          this.$request.postHttp({
            url: "/system/createrole",
            data: JSON.stringify(this.selectTable),
            success: (data) => {
              this.$message.success(data.msg)
              this.dialogFormVisible = false
              this.getList();
            },
            error: (error) => {
              console.error("Error:", error);
              // 执行失败时的操作
            },
          })
        } else {
          // 校验失败
          this.$message.error('请完善表单信息');
          return false;
        }
      });

    }

  },
}
</script>
<style>
#rccx .el-date-editor.el-input {
  width: 100px !important;
}

selectupwidth el-select {
  width: 120px;
}

/*#roleListpage .el-pager li.active {
  color: white;
}*/
</style>